"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyFooterBar = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var container_1 = require("../container");
var defaultProps = {
    grid: "one",
};
var cx = bind_1.default.bind(styles);
var StickyFooterBar = /** @class */ (function (_super) {
    __extends(StickyFooterBar, _super);
    function StickyFooterBar(props) {
        var _this = _super.call(this, props) || this;
        _this.element = null;
        _this.initialHeight = 0;
        _this.state = {
            fixed: false,
        };
        _this._reposition = function () {
            if (!_this.footer) {
                return;
            }
            var remainingScroll = _this.body.clientHeight - window.innerHeight - window.pageYOffset;
            var fixed = remainingScroll <= _this.footer.clientHeight;
            _this.setState({ fixed: fixed });
        };
        _this.element = React.createRef();
        return _this;
    }
    StickyFooterBar.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this._reposition);
        this._reposition();
    };
    StickyFooterBar.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this._reposition);
    };
    Object.defineProperty(StickyFooterBar.prototype, "previousElement", {
        get: function () {
            return this.footer.previousSibling;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StickyFooterBar.prototype, "footer", {
        get: function () {
            return document.querySelector("footer");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StickyFooterBar.prototype, "body", {
        get: function () {
            return document.querySelector("body");
        },
        enumerable: false,
        configurable: true
    });
    StickyFooterBar.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, grid = _b.grid;
        var fixed = this.state.fixed;
        if (!this.initialHeight && this.element.current) {
            this.initialHeight = this.element.current.clientHeight;
            var originalPadding = parseInt(window.getComputedStyle(this.previousElement).paddingBottom);
            this.previousElement.style.paddingBottom = "".concat(originalPadding +
                this.initialHeight, "px");
        }
        var className_ = cx((_a = {
                outer: true
            },
            _a[className] = className,
            _a.fixed = fixed,
            _a));
        return (React.createElement("div", { ref: this.element, className: className_, style: {
                top: this.state.fixed ? "unset" : "auto",
                height: this.initialHeight ? this.initialHeight : "auto",
            } },
            React.createElement(container_1.Container, { grid: grid }, children)));
    };
    StickyFooterBar.defaultProps = defaultProps;
    return StickyFooterBar;
}(React.Component));
exports.StickyFooterBar = StickyFooterBar;
exports.default = StickyFooterBar;
//# sourceMappingURL=sticky-footer-bar.js.map